import React from "react";

export default function Logo() {
  return (
    <div className="w-8 h-8">
      <svg
        width="32"
        height="32"
        viewBox="0 0 1080 1080"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="1080"
          height="1080"
          rx="540"
          fill="white"
        />
        <path
          d="M539.5 541.294L320.353 322.147L504.145 138.355C523.671 118.829 555.329 118.829 574.855 138.355L758.647 322.147L539.5 541.294Z"
          fill="#0077CC"
        />
        <path
          d="M539.5 541.294L320.353 322.147L504.145 138.355C523.671 118.829 555.329 118.829 574.855 138.355L758.647 322.147L539.5 541.294Z"
          stroke="black"
        />
        <path
          d="M321.147 759.647L137.355 575.856C117.829 556.33 117.829 524.671 137.355 505.145L321.147 321.353L540.294 540.5L321.147 759.647Z"
          fill="#012C3C"
        />
        <path
          d="M321.147 759.647L137.355 575.856C117.829 556.33 117.829 524.671 137.355 505.145L321.147 321.353L540.294 540.5L321.147 759.647Z"
          stroke="black"
        />
        <path
          d="M941.645 505.145C961.171 524.671 961.171 556.33 941.645 575.856L757.853 759.647L538.706 540.5L757.853 321.353L941.645 505.145Z"
          fill="#0288E8"
        />
        <path
          d="M941.645 505.145C961.171 524.671 961.171 556.33 941.645 575.856L757.853 759.647L538.706 540.5L757.853 321.353L941.645 505.145Z"
          stroke="black"
        />
        <path
          d="M539.5 539.706L758.647 758.853L574.855 942.645C555.329 962.171 523.671 962.171 504.145 942.645L320.353 758.853L539.5 539.706Z"
          fill="#129CFF"
        />
      </svg>
    </div>
  );
}
